export const images = [
    { id:1, original: '/images/services/1/sub-categories/4/c1-s4-p1.jpg' },
]
